import { parse } from "query-string";
import { ActivitySummaryFilters } from "us.collection.admin/constants";
import { ENTITY_TRANSLATION_KEYS, EntityType } from "../Types";

/**
 * @function
 * @description - return entity type from url params and data source
 * @param activitySummaryList {Array<any>} activity summary list data source
 * @param urlSearchParams {string} url params in search
 * @returns {string} return entity type
 */
export const getSelectedEntityType = (
  activitySummaryList: Array<any>,
  urlSearchParams: string,
): string => {
  try {
    const currentFilters = parse(urlSearchParams);
    const entityTypeInUrl = currentFilters[ActivitySummaryFilters.ENTITY_TYPE];
    const entityType =
      (entityTypeInUrl &&
        activitySummaryList.find(
          ({ entitytype }: { entitytype: string }) =>
            entityTypeInUrl == entitytype,
        )?.["entitytype"]) ??
      activitySummaryList[0]["entitytype"];
    return entityType;
  } catch (error) {
    return "";
  }
};

/**
 * Get translation key from entity type
 * @param entityType {string} entity type
 * @returns {string} translation key for the entity type
 */
export const getEntityTranslationKey = (entityType?: string | null): string => {
  try {
    if (!entityType) return "";

    return ENTITY_TRANSLATION_KEYS[entityType as EntityType] ?? "";
  } catch (error) {
    return "";
  }
};
